import { logger } from "@justhome/common";
import {
  Assumptions,
  GetAssumptionsVariables,
  fetchGetAssumptions,
} from "@justhome/common/api/core";

export async function fetchGetAssumptionsWithLogging(
  variables: GetAssumptionsVariables,
): Promise<Assumptions> {
  try {
    return fetchGetAssumptions(variables);
  } catch (error) {
    logger.error("Error while getting all assumptions.", error, variables);
    throw error;
  }
}
